import { gql } from '@/__generated__';
import { type GetDeviceHardwareConfigurationQuery } from '@/__generated__/graphql';

export type Device = GetDeviceHardwareConfigurationQuery['device'];

const GET_DEVICE_HARDWARE_CONFIGURATION = gql(`#graphql
	query GetDeviceHardwareConfiguration($deviceId: ID!) {
		device(input: { id: $deviceId }) {
			id
			profile {
				id
				name
				type
				sensor
				source
				sourceInfo
				organization {
					id
					name
				}
				project
				created
				dateAction
			}
			hardwareConfiguration {
				id
				account {
					id
					email
					name
					lastnames
				}
				images
				googleDriveUrl
				dateAction
				energizationOption {
					id
					name
				}
				powerSupplyVoltageOption {
					id
					name
				}
				powerSupplyModel
				powerSupplySerialNumber
				powerSupplyBrand
				solarControllerModelOption {
					id
					name
				}
				numberSolarPanelsControllers
				quantityBattery
				modelBattery
				technologyOption {
					id
					name
				}
				batteryCapacityOption {
					id
					name
				}
				batteryVoltageOption {
					id
					name
				}
				quantitySun
				modelsSun
				watts
				numberSun
				cpuOption {
					id
					name
				}
				batchNumberCpu
				auxiliaryOption {
					id 
					name
				}
				numberAuxiliary
				batchNumberAuxiliary
				internetConnectionOption {
					id
					name
				}
				modelsConnectionOption {
					id
					name
				}
				imei
				approved
				mobileOperatorOption {
						id
						name
				}
				phoneNumber
				dataPlanMobileOption {
					id
					name
				}
				iccid
				antennaOption {
					id
					name
				}
				mac
				configurationIp
				administrator
				networkName
				observation
				lockNumber
				ip
				imageVersion
				idEmnify
				satellitalTypeOption { 
					id
					name
				}
				satellitalSv
				satellitalHv
				satellitalHardwareName
				satellitalSerialName
				codeNumberWidgetlord
				serialNumberWidgetlord
				batchNumberWidgetlord
				batchNumberSimCard
				usbExtraction
			}
			sensors {
				id
				type: type {
					id
					name
					label: label
				}
				configuration {
					sensorId
					batchNumber
					serialNumber
					modbusId
					integrationDetail
					factorM
					offsetN
					attributes
					sensorModelOption {
						id
						name
					}
				}
			}
		}
	}
`);

export default GET_DEVICE_HARDWARE_CONFIGURATION;
